import {
  Box,
  Button,
  Collapse,
  HStack,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BoxHeader from "components/elements/BoxHeader";
import ContentBox from "components/elements/ContentBox";
import moment from "moment";
import { LoanContext } from "providers/loan";
import { useContext } from "react";
import { numberToDollar } from "utils/helpers";

const FundsVerified = () => {
  const { loan } = useContext(LoanContext);
  const { isOpen, onToggle } = useDisclosure();

  return (
    <ContentBox>
      <HStack justifyContent="space-between" alignItems="center">
        <BoxHeader mb="0px" title="Proof of Funds" />
        <Button
          py="0px"
          color="primary"
          size="sm"
          rightIcon={
            <FontAwesomeIcon
              size="sm"
              icon={["far", isOpen ? "chevron-down" : "chevron-right"]}
            />
          }
          onClick={onToggle}
          variant="ghost"
        >
          {isOpen ? "Hide" : "View"}
        </Button>
      </HStack>
      <Collapse in={isOpen}>
        <Box mt="16px">
          <Text mb="0px" fontSize="13px" lineHeight="24px">
            Proof of funds was verified for{" "}
            <strong>{numberToDollar(loan!.funds_requested)}</strong> on{" "}
            <strong>
              {moment(
                loan!.events.find((ev) => ev.name === "verified_funds")
                  ?.created_at,
              ).format("MM/DD/YYYY")}
            </strong>
            .
          </Text>
        </Box>
      </Collapse>
    </ContentBox>
  );
};

export default FundsVerified;
